class Dropdown {
  constructor(el) {
    this.el = el

    el.querySelector('.wz-dropdown__button').addEventListener('click', e => {
      e.preventDefault()
      el.classList.toggle('wz-dropdown--is-open')
    })
  }

  close() {
    this.el.classList.remove('wz-dropdown--is-open')
  }
}

export default Dropdown
